
import React from "react";

interface AuthModeToggleProps {
  isSignUp: boolean;
  setIsSignUp: (isSignUp: boolean) => void;
  onModeChange: () => void;
}

const AuthModeToggle = ({ isSignUp, setIsSignUp, onModeChange }: AuthModeToggleProps) => {
  return (
    <div className="text-center my-4">
      <button
        type="button"
        onClick={() => {
          setIsSignUp(!isSignUp);
          onModeChange();
        }}
        className="text-sm text-blue-600 hover:underline"
      >
        {isSignUp ? "Already have an account? Sign In" : "Need an account? Sign Up"}
      </button>
    </div>
  );
};

export default AuthModeToggle;
